import React from 'react'

const Karmareceived = () => {
  return (
    <div>
      received
    </div>
  )
}

export default Karmareceived
